var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg333Fm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M233.65 349.13l86.686-238.421c39.981.633 75.703 13.602 106.74 38.845-28.854 79.365-57.585 158.397-86.531 238.013-32.38-21.474-68.053-34.377-106.895-38.437zM330.838 80.083c4.42-12.027 8.563-23.458 12.878-34.826.492-1.296 1.739-2.749 2.988-3.244 13.553-5.377 27.471-9.129 42.2-9.437 20.949-.437 35.875 10.381 48.05 25.878 5.233 6.663 9.434 14.146 13.986 21.33.604.951 1.014 2.52.665 3.501-4.166 11.724-8.492 23.391-12.912 35.446-32.797-21.733-68.405-34.528-107.855-38.648zM251.47 466.013c-.836-1.796-1.426-3.058-2.015-4.322-10.146-21.757-20.293-43.514-30.436-65.271-1.477-3.171.235-13.635 2.837-15.838.808-.685 2.329-.77 3.512-.734 37.824 1.162 71.613 13.455 101.417 36.785 2.047 1.602 2.333 2.969 1.693 5.562-1.72 6.972-5.656 10.951-12.381 13.901-21.527 9.446-42.704 19.694-64.627 29.917z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.597 62.5H171.59699999999998V162.5H71.597z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.097 202.5H172.09699999999998V302.5H72.097z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.347 342.5H172.34699999999998V442.5H72.347z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg333Fm);
export default __webpack_public_path__ + "static/media/333fm.cb2c0c7a65975be8e5e9eac32413784a.svg";
export { ForwardRef as ReactComponent };